import {h, Fragment} from "preact"
import { translatedText } from "./utils/translatedText";

export default function PopularSearchQueries() {
  const terms = ["cap", "overshirt", "vest", "suit", "golfBag"];

  // Injects a tiny CSS rule once to hide the input text when we add the attribute
  const ensureMaskStyle = () => {
    if (document.getElementById("silent-type-style")) return;
    const style = document.createElement("style");
    style.id = "silent-type-style";
    style.textContent = `
      #search_input[data-silent-typing="1"] {
        color: transparent !important;
        caret-color: transparent !important;
        -webkit-text-fill-color: transparent !important;
      }
    `;
    document.head.appendChild(style);
  };

  const setNativeValue = (el, val) => {
    const setter = Object.getOwnPropertyDescriptor(
      window.HTMLInputElement.prototype, "value"
    )?.set;
    setter && setter.call(el, val);
  };

  const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

  // Emulate keystrokes quickly, but invisibly
  const silentTypeAndSearch = async (term) => {
    const input = document.getElementById("search_input");
    if (!input) return;

    ensureMaskStyle();

    const originalValue = input.value;
    input.setAttribute("data-silent-typing", "1"); // hide text
    input.blur(); // avoid caret blink in some browsers

    // Type term step-by-step; 25–40ms usually matches debounced instant-search nicely
    for (let i = 1; i <= term.length; i++) {
      setNativeValue(input, term.slice(0, i));
      input.dispatchEvent(new Event("input", { bubbles: true }));
      // keep it snappy—tune this if Nosto needs a different cadence
      await sleep(30);
    }

    // Make sure final value is the full term
    setNativeValue(input, term);
    input.dispatchEvent(new Event("input", { bubbles: true }));

    // Restore visuals in the same frame before submit
    input.removeAttribute("data-silent-typing");

    // Submit quickly (microtask lets state settle)
    const form = input.form || input.closest("form");
    if (form) {
      Promise.resolve().then(() => {
        if (form.requestSubmit) form.requestSubmit();
        else form.dispatchEvent(new Event("submit", { bubbles: true, cancelable: true }));
      });
    } else {
      input.dispatchEvent(new KeyboardEvent("keydown", { key: "Enter", code: "Enter", bubbles: true }));
    }

    // Optional: if you want to restore original value visually after submit:
    // setNativeValue(input, originalValue);
    // input.dispatchEvent(new Event("input", { bubbles: true }));
  };

  const handleSearchClick = (term) => {
    silentTypeAndSearch(term);
  };

  return (
    <>
      <p className="text-13-120--0.5-900 capitalize text-black-55 mb-16 lg:mb-12">
        {translatedText("popularSearches")}
      </p>

      <div className="mb-6">
        {terms.map((term) => (
          <button
            key={term}
            type="button"
            onClick={() => handleSearchClick(term)}
            className="block text-13-120--0.5-700 mb-12 text-black-55 capitalize"
          >
            {translatedText(term)}
          </button>
        ))}
      </div>
    </>
  );
}


// import { translatedText } from "./utils/translatedText";

// export default function PopularSearchQueries() {
//   const terms = ["cap", "overshirt", "vest", "suit", "golfBag"];

//   const handleSearchClick = (term) => {
//     const input = document.getElementById("search_input");
//     if (!input) return;

//     // Set value (so frameworks detect it), then emit 'input'
//     const setter = Object.getOwnPropertyDescriptor(
//       window.HTMLInputElement.prototype, "value"
//     )?.set;
//     setter && setter.call(input, term);
//     input.dispatchEvent(new Event("input", { bubbles: true }));

//     const form = input.form || input.closest("form");
//     if (form) {
//       // Microtask = faster than setTimeout; lets state settle
//       Promise.resolve().then(() => {
//         if (form.requestSubmit) form.requestSubmit();
//         else form.dispatchEvent(new Event("submit", { bubbles: true, cancelable: true }));
//       });
//     } else {
//       // No form: emulate a single Enter press
//       input.dispatchEvent(new KeyboardEvent("keydown", { key: "Enter", code: "Enter", bubbles: true }));
//     }
//   };

//   return (
//     <>
//       <p className="text-13-120--0.5-900 capitalize text-black-55 mb-16 lg:mb-12">
//         {translatedText("popularSearches")}
//       </p>

//       <div className="mb-6">
//         {terms.map((term) => (
//           <button
//             key={term}
//             type="button"
//             onClick={() => handleSearchClick(term)}
//             className="block text-13-120--0.5-700 mb-12 text-black-55 uppercase"
//           >
//             {translatedText(term)}
//           </button>
//         ))}
//       </div>
//     </>
//   );
// }


// import { translatedText } from "./utils/translatedText";

// export default function PopularSearchQueries() {
//   const terms = ['cap', 'overshirt', 'vest', 'suit', 'golfBag']; 

//   const handleSearchClick = (term) => {
//     const input = document.getElementById('search_input');
  
//     if (input) {
//       // Set the value as if typed by the user
//       const nativeInputValueSetter = Object.getOwnPropertyDescriptor(
//         window.HTMLInputElement.prototype,
//         'value'
//       )?.set;
//       nativeInputValueSetter?.call(input, term);
  
//       // Trigger input event
//       const inputEvent = new Event('input', { bubbles: true });
//       input.dispatchEvent(inputEvent);
  
//       // Focus the input to emulate user interaction
//       input.focus();
  
//       // Optionally trigger a 'focus' event manually (in case some systems use it)
//       const focusEvent = new FocusEvent('focus', { bubbles: true });
//       input.dispatchEvent(focusEvent);
//     } else {
//       console.warn('Search input with id "search_input" not found.');
//     }
//   };  

//   return (
//     <>
//       <p className="text-13-120--0.5-900 capitalize text-black-55 mb-16 lg:mb-12">
//         {translatedText("popularSearches")}
//       </p>

//       <div className="mb-6">
//         {terms.map((term) => (
//           <button
//             key={term}
//             type="button"
//             onClick={() => handleSearchClick(term)}
//             className="block text-13-120--0.5-700 mb-12 text-black-55"
//           >
//             {translatedText(term)}
//           </button>
//         ))}
//       </div>
//     </>
//   );
// }
